import React, { useEffect, useRef } from "react";
import { loadModules } from "esri-loader";
import styled from "styled-components";
import PropTypes from "prop-types";

const MapContainer = styled.div`
	width: 100%;
	height: 100%;
`;

export const WebMap = ({ mapId, portalUrl }) => {
	const mapRef = useRef();

	useEffect(() => {
		loadModules(["esri/WebMap", "esri/views/MapView", "esri/config"], {
			css: true,
		}).then(([WebMap, MapView, esriConfig]) => {
			esriConfig.portalUrl = portalUrl;
			const map = new WebMap({ portalItem: { id: mapId } });

			const view = new MapView({
				container: mapRef.current,
				map: map,
				zoom: 6,
				navigation: {
					mouseWheelZoomEnabled: false,
					browserTouchPanEnabled: false,
				},
			});

			return () => {
				if (view) {
					// destroy the map view
					view.container = null;
				}
			};
		});
	}, [mapId]);

	return <MapContainer className="webmap" ref={mapRef} />;
};

WebMap.propTypes = {
	mapId: PropTypes.string,
};

export default WebMap;
